// Platz.jsx — Platzabzeichen für alle Leinwände.
//
// Vorher stand auf jeder Anzeige 🥇🥈🥉. Diese Zeichen rendert das
// Betriebssystem: sie tragen BLAUE Bänder — in einer Leinwand aus Rot, Gold
// und Schwarz drei blaue Kleckse —, sie sehen auf dem Windows-Notebook am
// Beamer anders aus als auf dem Mac, und aus zwanzig Metern sind Gold, Silber
// und Bronze nicht zu unterscheiden, weil die Farbe nur im Band steckt.
//
// Hier ist es ein Ring in der Platzfarbe mit der Ziffer darin: Fläche statt
// Detail, auf jedem Gerät gleich.
import React from 'react';
import './Platz.css';

export const PLATZ_FARBEN = { 1: '#d4af37', 2: '#c0c0c0', 3: '#cd7f32' };

export default function Platz({ platz, gross = false, className = '' }) {
  const farbe = PLATZ_FARBEN[platz];
  if (!farbe) {
    return <span className={`lw-platz schlicht ${className}`}>{platz}.</span>;
  }
  return (
    <span
      className={`lw-platz medaille ${gross ? 'gross' : ''} ${className}`}
      style={{ '--platz-farbe': farbe }}
    >
      {platz}
    </span>
  );
}
